import DispensaryPage from 'src/dispensary/home';
import { MainDispensaryLayout } from 'src/components/layouts/main-dispensary-layout';
import { withLayout } from 'src/components/layouts/with-layout';

export default withLayout(DispensaryPage, MainDispensaryLayout);
